<template>
  <div class="pa-6 bg-custom">
    <h2 class="mb-4">
      {{ $vuetify.lang.t('$vuetify.courseManagement.stepCourse.lecture') }}
    </h2>

    <v-sheet color="white" class="mb-6 pa-6">
      <v-row no-gutters class="mb-3">
        <v-col class="body-1 font-weight-medium text-custom-title">
          {{ $vuetify.lang.t('$vuetify.studyingType') }}
          <span class="red--text">*</span>
        </v-col>
      </v-row>

      <v-row no-gutters class="align-center">
        <v-radio-group
          class="mt-0 pa-0"
          @change="saveStudyingType"
          v-model="learningOrder"
          row
          hide-details=""
        >
          <v-radio
            :label="$vuetify.lang.t('$vuetify.independentStudy')"
            :value="false"
          ></v-radio>
          <v-radio
            :label="$vuetify.lang.t('$vuetify.sequentlyStudy')"
            :value="true"
          ></v-radio>
        </v-radio-group>

        <div class="body-1 orange--text" v-show="studyingTypeSaving">
          Saving studying type ...
        </div>
        <div class="body-1 green--text" v-show="studyingTypeSuccess">
          Studying type has been saved.
        </div>
        <div class="body-1 red--text" v-show="studyingTypeFail">
          Fail to save studying type.
        </div>
      </v-row>
    </v-sheet>

    <v-sheet color="white" class="mb-6 pa-6">
      <v-row no-gutters>
        <v-col lg="11" cols="11">
          <div
            class="body-1 font-weight-medium text-custom-title mb-4 d-flex align-center"
          >
            <v-icon color="info" class="mr-2">mdi-information-outline</v-icon>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.instructionStudyingDetail'
              )
            }}
          </div>
          <p class="body-2">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.instructionStudyingIndependent'
              )
            }}
          </p>
          <p class="body-2 mb-0">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.instructionStudyingSequently'
              )
            }}
          </p>
        </v-col>
      </v-row>
    </v-sheet>

    <!-- <v-row class="px-5">
      <v-col cols="8">
        <div class="title">
          <v-icon color="info">mdi-information-outline</v-icon>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.instructionStudyingDetail'
            )
          }}
        </div>
        <div>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.instructionStudyingIndependent'
            )
          }}
          <br />
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.instructionStudyingSequently'
            )
          }}
        </div>
      </v-col>
    </v-row> -->

    <v-row no-gutters class="mb-2">
      <v-col cols="12">
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
            @click="showDialogForm"
          >
            <v-icon left>mdi-plus</v-icon>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.addSection'
              )
            }}
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <draggable
          :list="sections"
          :disabled="!enabled"
          class="list-group"
          ghost-class="ghost"
          @end="checkMoveSection"
        >
          <div
            class="card-list mb-6"
            v-for="(section, index) in sections"
            :key="section.id + index"
          >
            <v-card
              outlined
              elevation="0"
              class="mt-4 py-0 card-custom-lecture"
              width="100%"
            >
              <v-list-item>
                <v-list-item-avatar class="my-0">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on">
                        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
                        <v-icon>mdi-drag-horizontal</v-icon>
                      </v-btn>
                    </template>
                    <span class="subtitle-1">{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.dragToMoveSequence'
                      )
                    }}</span>
                  </v-tooltip>
                </v-list-item-avatar>
                <v-list-item-content class="pa-0">
                  <v-list-item-title>
                    <!-- <span class="title my-auto font-weight-light mr-2">{{(index+1)+" "}}</span> -->
                    {{ section.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ 'Instructor: ' }}
                    {{ section.teacher.displayName }}
                  </v-list-item-subtitle>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        @click="openExpand(index)"
                        icon
                        class="md-position-absolute centerx-ele mt-2 active"
                        :id="`centerx-ele-${index}`"
                      >
                        <v-icon class="icon">mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <span class="subtitle-1">{{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.clickToHideOrShow'
                      )
                    }}</span>
                  </v-tooltip>
                </v-list-item-content>
                <v-list-item-action>
                  <v-row align="center" justify="end">
                    <v-btn
                      elevation="0"
                      class="mb-0 body-2 text-primary text-capitalize"
                      color="white"
                      @click="editSection(section)"
                    >
                      <p class="mb-0">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.edit'
                          )
                        }}
                      </p>
                    </v-btn>
                    <v-divider inset vertical class="mb-2 mx-1"></v-divider>
                    <v-btn
                      elevation="0"
                      class="mb-0 body-2 error--text text-capitalize"
                      color="white"
                      @click="deleteLectureConfirm(section.id, null)"
                    >
                      <p class="mb-0">
                        {{
                          $vuetify.lang.t(
                            '$vuetify.courseManagement.lectureStep.delete'
                          )
                        }}
                      </p>
                    </v-btn>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
            </v-card>

            <!-- <v-toolbar color="grey lighten-5" class="md-position-relative lecture-card">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-app-bar-nav-icon></v-app-bar-nav-icon>
                </v-btn>
              </template>
              <span
                class="subtitle-1"
              >{{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.dragToMoveSequence")}}</span>
            </v-tooltip>

            <v-toolbar-title>{{section.name}}</v-toolbar-title>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="openExpand(index)"
                  icon
                  class="md-position-absolute centerx-ele mt-2 active"
                  :id="`centerx-ele-${index}`"
                >
                  <v-icon class="icon">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <span
                class="subtitle-1"
              >{{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.clickToHideOrShow")}}</span>
            </v-tooltip>
            <v-spacer></v-spacer>

            <v-chip
              color="primary"
              class="noti font-weight-bold mx-2 subtitle-1"
            >{{section.number + " " + $vuetify.lang.t("$vuetify.courseManagement.lectureStep.lecture")}}</v-chip>
            <v-btn
              class="mx-2 px-7 subtitle-1"
              color="blue-grey"
              dark
              rounded
              @click="editSection(section)"
            >
              <v-icon left>mdi-file-edit</v-icon>
              {{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.editOrAddSection")}}
            </v-btn>
            <v-btn
              class="px-5 subtitle-1"
              color="error"
              dark
              rounded
              @click="deleteLectureConfirm(section.id, null)"
            >
              <v-icon left>mdi-delete</v-icon>
              {{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.removeSection")}}
            </v-btn>
          </v-toolbar>-->
            <v-card outlined elevation="0" class="mt-0 card-child-lecture">
              <div
                class="expand-panel active mt-0 pt-2"
                :id="`expand-${index}`"
              >
                <p
                  class="subtitle-1 text-center blue-grey--text my-3"
                  v-if="section.lectures.length == 0"
                >
                  No data yet.Please click "+
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.addLecture'
                    )
                  }}" button to add question
                </p>
                <!-- <v-divider
                  v-if="section.lectures.length == 0"
                  class="ma-0"
                ></v-divider> -->
                <draggable
                  :list="section.lectures"
                  :disabled="!enabled"
                  class="list-group"
                  ghost-class="ghost"
                  @end="checkMoveLecture(index)"
                >
                  <div
                    v-for="(lecture, indexlecture) in section.lectures"
                    :key="lecture._id"
                  >
                    <v-list-item class="pl-8">
                      <v-list-item-avatar class="my-0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on">
                              <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
                              <v-icon>mdi-drag-horizontal</v-icon>
                            </v-btn>
                          </template>
                          <span class="subtitle-1">{{
                            $vuetify.lang.t(
                              '$vuetify.courseManagement.lectureStep.dragToMoveSequence'
                            )
                          }}</span>
                        </v-tooltip>
                      </v-list-item-avatar>
                      <v-list-item-content class="pa-0">
                        <v-list-item-title>
                          <span class="title my-auto font-weight-light mr-2">{{
                            indexlecture + 1 + ' '
                          }}</span>
                          {{ lecture.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-icon>{{ lecture.icon }}</v-icon>
                          {{ lecture.name }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-row align="center" justify="end">
                          <div
                            class="d-flex align-center"
                            v-if="lecture.type == 'EXAM'"
                          >
                            <span
                              v-if="lecture.exams[0].active"
                              class="primary--text subtitle-1 font-italic font-weight-light"
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.publish'
                                )
                              }}</span
                            >
                            <span
                              v-else
                              class="font-italic subtitle-1 font-weight-light"
                              >{{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.disable'
                                )
                              }}</span
                            >
                            <v-switch
                              inset
                              v-model="lecture.exams[0].active"
                              class="px-6"
                              color="primary"
                              @click="
                                checkToPublish(
                                  index,
                                  indexlecture,
                                  lecture.exams[0].active,
                                  lecture._id,
                                  lecture.exams[0]._id,
                                  lecture.exams[0].questions.length,
                                  lecture.exams[0].randomSetting
                                )
                              "
                            ></v-switch>
                          </div>
                          <v-btn
                            elevation="0"
                            class="mb-0 body-2 text-primary text-capitalize"
                            color="white"
                            @click="
                              openEditDialog(
                                lecture.type,
                                section.id,
                                lecture._id,
                                section.lectures
                              )
                            "
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.edit'
                                )
                              }}
                            </p>
                          </v-btn>

                          <v-divider
                            inset
                            vertical
                            class="mb-2 mx-1"
                          ></v-divider>

                          <v-btn
                            elevation="0"
                            class="mb-0 body-2 error--text text-capitalize"
                            color="white"
                            @click="
                              deleteLectureConfirm(section.id, lecture._id)
                            "
                          >
                            <p class="mb-0">
                              {{
                                $vuetify.lang.t(
                                  '$vuetify.courseManagement.lectureStep.delete'
                                )
                              }}
                            </p>
                          </v-btn>
                        </v-row>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider
                      v-show="indexlecture != lecture.length - 1"
                      class="ma-0"
                    ></v-divider>
                  </div>
                  <!-- <v-divider class="mt-3"></v-divider> -->
                </draggable>
                <v-row justify="center">
                  <button-add-lecture
                    :key="section.id"
                    :sectionId="section.id"
                    :lectures="section.lectures"
                    :reload="reload"
                    :courseId="$route.query.id"
                  />
                </v-row>
              </div>
            </v-card>
          </div>
        </draggable>
      </v-col>
    </v-row>

    <!-- <v-card class="ma-5 font-weight-light" elevation="0"> -->

    <!-- <v-expansion-panels v-model="open_panel_list" multiple> -->
    <!--<div>{{open_panel_list}}</div>
      <div>{{old_open_panel}}</div>
      <div>{{before_move_list}}</div>-->
    <!-- <draggable
        :list="sections"
        :disabled="!enabled"
        class="list-group"
        ghost-class="ghost"
        @start="checkOpenPanel()"
        @end="checkMoveSection()"
      >
        <v-expansion-panel v-for="(section,index) in sections" :key="section.id + index">
          <v-expansion-panel-header>
            <v-toolbar color="grey lighten-5" class="md-position-relative">
              <v-btn icon>
                <v-app-bar-nav-icon></v-app-bar-nav-icon>
              </v-btn>

              <v-toolbar-title>{{section.name}}</v-toolbar-title>
              <v-btn
                @click="openExpand(index)"
                icon
                class="md-position-absolute centerx-ele mt-2 active"
                :id="`centerx-ele-${index}`"
              >
                <v-icon class="icon">mdi-chevron-down</v-icon>
              </v-btn>
              <v-spacer></v-spacer>

              <div class="noti mr-3">
                <p class="font-weight-bold text-center">{{section.number}}</p>
              </div>
              <v-btn icon @click="editSection(section)">
                <v-icon>mdi-file-edit</v-icon>
              </v-btn>
              <v-btn icon @click="openDeleteSectionDialog(section.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-toolbar>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <draggable
              :list="section.lectures"
              :disabled="!enabled"
              class="list-group"
              ghost-class="ghost"
              @end="checkMoveLecture(index)"
            >
              <v-list-item v-for="lecture in section.lectures" :key="lecture._id">
                <v-btn icon>
                  <v-app-bar-nav-icon></v-app-bar-nav-icon>
                </v-btn>
                <v-list-item-avatar class="mr-5">
                  <v-icon :class="[lecture.iconClass]" v-text="lecture.icon"></v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="lecture.title"></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    icon
                    @click="openEditDialog(lecture.type,section.id,lecture._id,section.lectures)"
                  >
                    <v-icon color="grey lighten-1">mdi-pencil</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn
                    icon
                    @click="openDeleteLectureDialog(section.id, lecture._id, section.lectures)"
                  >
                    <v-icon color="grey lighten-1">mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </draggable>
            <v-divider class="mt-3"></v-divider>
            <div>
              <button-add-lecture
                :key="section.id"
                :sectionId="section.id"
                :lectures="section.lectures"
                :reload="reload"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </draggable>
      </v-expansion-panels>-->

    <!-- <template v-slot:activator="{ on }"> -->
    <v-row no-gutters class="justify-center" v-if="sections.length != 0">
      <v-btn
        elevation="0"
        class="pl-5 pr-5 xs-full-width font-weight-light button-primary white--text"
        @click="showDialogForm"
      >
        <v-icon left>mdi-plus</v-icon>
        {{
          $vuetify.lang.t('$vuetify.courseManagement.lectureStep.addSection')
        }}
      </v-btn>
    </v-row>
    <!-- </template> -->
    <v-dialog v-model="activeDialog" persistent max-width="500" color="white">
      <v-card>
        <!-- <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title> -->

        <v-card-title class="mb-3">{{
          $vuetify.lang.t('$vuetify.courseManagement.lectureStep.EnableSuspend')
        }}</v-card-title>
        <v-card-text>
          <!-- <div class="d-flex align-center">
              <v-switch inset v-model="active" class="pr-3" color="primary"></v-switch>
              <span
                v-if="active"
                class="primary--text subtitle-1 font-italic font-weight-light"
              >(เปิดการใช้งาน)</span>
              <span v-else class="subtitle-1 font-italic font-weight-light">(ระงับการใช้งาน)</span>
            </div>
            <div v-if="active">
              <div class="d-flex align-center">
                <v-switch inset v-model="isModifyStartEndTime" class="pr-3" color="primary"></v-switch>
                <span
                  v-if="!isModifyStartEndTime"
                  class="subtitle-1 font-italic font-weight-light"
                >(ไม่กำหนดเวลา)</span>
                <span
                  v-else
                  class="primary--text subtitle-1 font-italic font-weight-light"
                >(กำหนดเวลาเปิดการใช้งาน)</span>
              </div>
              <div v-if="isModifyStartEndTime">
                <div class="datetime d-flex align-center justify-between mb-5">
                  <span v-if="startTime.length>0" class="subtitle-1 font-weight-light ml-3">เริ่ม:</span>
                  <datetime
                    type="datetime"
                    input-id="startDate"
                    v-model="startTime"
                    format="dd/MM/yyyy HH:mm:ss"
                    placeholder="วัน-เวลา เริ่ม"
                    class="subtitle-1 font-weight-light ml-3"
                  ></datetime>
                </div>
                <div class="datetime d-flex align-center justify-between">
                  <span v-if="endTime.length>0" class="subtitle-1 font-weight-light ml-3">สิ้นสุด:</span>
                  <datetime
                    type="datetime"
                    input-id="endDate"
                    v-model="endTime"
                    format="dd/MM/yyyy HH:mm:ss"
                    placeholder="วัน-เวลา สิ้นสุด"
                    class="subtitle-1 font-weight-light ml-3"
                  ></datetime>
                </div>
              </div>
            </div>-->
          <p class="subtitle-1 font-weight-light">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.alertSetTimeExam'
              )
            }}
          </p>
          <p v-if="!active" class="subtitle-1 font-weight-light">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.alertEnable'
              )
            }}
          </p>
          <p v-if="active" class="subtitle-1 font-weight-light">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.alertSuspend'
              )
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="px-7 ma-2 subtitle-2 font-weight-light"
            color="grey darken-1"
            outlined
            :disabled="loading"
            @click="closeActiveDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >

          <v-btn
            class="px-7 ma-2 subtitle-2 button-primary font-weight-light"
            :disabled="loading"
            :loading="loading"
            @click="saveActiveDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editSectionDialog" persistent max-width="600px">
      <v-card class="font-weight-light">
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <v-icon left>mdi-book-open-page-variant</v-icon>
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.editOrAddSection'
              )
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn icon dark @click="checkToSave" v-on="on">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </template>
            <span class="subtitle-1">{{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.tooltripClose'
              )
            }}</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            v-on:submit.prevent="insertOrUpdateSection"
          >
            <v-row>
              <v-col cols="12">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.sectionName'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-text-field
                  v-model="sectionName"
                  :rules="sectionRule"
                  outlined
                  class="font-weight-light"
                  clearable
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.plsEnterSectionName'
                    )
                  "
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="pa-0">
                  <p class="title">
                    {{
                      $vuetify.lang.t(
                        '$vuetify.courseManagement.lectureStep.addTutor'
                      )
                    }}
                  </p>
                  <!-- <v-spacer></v-spacer>
                    <v-btn
                      v-if="isSearch == false"
                      elevation="0"
                      class="mb-4 body-2 text-primary text-capitalize"
                      color="white"
                      @click="isSearch = true"
                    >
                      {{
                        $vuetify.lang.t(
                          "$vuetify.instructorManagement.filterBar.search"
                        )
                      }}
                    </v-btn> -->
                  <v-btn
                    v-if="isSearch == true"
                    elevation="0"
                    class="body-2"
                    color="white"
                    @click="cancelSearch"
                  >
                    {{
                      $vuetify.lang.t(
                        '$vuetify.instructorManagement.filterBar.cancelSearch'
                      )
                    }}
                  </v-btn>
                </v-card-actions>
                <v-text-field
                  v-if="isSearch == true"
                  class="subtitle-2 text-field-border"
                  outlined
                  height="40px"
                  v-model="searchdata"
                  @change="searchInfo(searchdata)"
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.instructorManagement.filterBar.searchNameEmail'
                    )
                  "
                  clearable
                ></v-text-field>
                <v-autocomplete
                  v-model="selectInstructor"
                  :items="instructorList"
                  item-text="fullName"
                  item-value="id"
                  :search-input.sync="search"
                  class="font-weight-light"
                  outlined
                  height="40px"
                  :placeholder="$vuetify.lang.t('$vuetify.chooseInstructor')"
                  background-color="white"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
            outlined
            @click="checkToSave"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >
          <v-btn
            elevation="0"
            class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
            :disabled="!valid"
            @click="insertOrUpdateSection"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.save')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <button-edit-lecture
      :isOpen.sync="editLectureDialog"
      :type.sync="editLectureType"
      :isLectureOpen="true"
      :sectionId.sync="editSectionId"
      :lectureId.sync="editLectureId"
      :lectures.sync="editLecture"
      :reload="reload"
      :closeLectureDialog.sync="closeLectureDialog"
      :courseId="$route.query.id"
    />
    <v-dialog v-model="deleteDialog" persistent max-width="350">
      <v-card class="pt-10">
        <!-- <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title> -->

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertDeleteLesson'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="closeDeleteDialog">{{
            $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
          }}</v-btn>

          <v-btn color="green darken-1" text @click="deleteItem">{{
            $vuetify.lang.t('$vuetify.courseManagement.lectureStep.ok')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" persistent max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertDeleteLesson'
          )
        }}</v-card-title>
        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertDeleteLessonCantBringData'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            class="px-9 ma-2"
            dark
            outlined
            @click="dialogDelete = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >
          <v-btn
            class="px-10 ma-2"
            color="error darken-1"
            dark
            @click="
              delLectureId !== null
                ? deleteLecture(delSectionId, delLectureId)
                : deleteSection(delSectionId)
            "
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertSuccessfullyDeleteLesson'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertLessonDeletedFromSystem'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t('$vuetify.courseManagement.lectureStep.done')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- </v-card> -->
    <!-- <v-divider class="mb-5 mt-5"></v-divider>
    <v-row>
      <v-col>
        <div class="my-2 float-right">
          <v-btn class="mr-3 title" color="blue-grey" outlined rounded large @click="goBack">
            <v-icon class="mr-3">mdi-arrow-left-circle</v-icon>
            {{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.back")}}
          </v-btn>
          <v-btn class="pr-8 pl-9 title" color="blue-grey" dark large rounded @click="goNext">
            {{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.next")}}
            <v-icon class="ml-3">mdi-arrow-right-circle</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>-->
    <v-dialog v-model="warnningToSaveDialog" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.alertNotSavedChange'
          )
        }}</v-card-title>
        <div class="px-5">
          <v-card-text>{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertNotSavedCreationOrEditing'
            )
          }}</v-card-text>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="closeSectionDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.cancel')
            }}</v-btn
          >

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="insertOrUpdateSection"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.save')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="noQuestionDialog"
      persistent
      max-width="500"
      color="white"
    >
      <v-card>
        <!-- <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title> -->
        <v-card-title class="mb-3">{{
          $vuetify.lang.t('$vuetify.courseManagement.lectureStep.EnableSuspend')
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.noQuestion'
              )
            }}
          </p>
          <!-- <p
              v-if="!active"
              class="subtitle-1 font-weight-light"
            >{{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.alertEnable")}}</p>
            <p
              v-if="active"
              class="subtitle-1 font-weight-light"
          >{{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.alertSuspend")}}</p>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn
              color="red darken-1"
              text
              @click="closeActiveDialog"
          >{{$vuetify.lang.t("$vuetify.courseManagement.lectureStep.cancel")}}</v-btn>-->

          <v-btn
            class="px-7 ma-2 subtitle-2 button-primary font-weight-light"
            text
            @click="closeNoQuestionDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.ok')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCanNotPublish"
      persistent
      max-width="450"
      color="white"
    >
      <v-card class="pa-3">
        <v-card-title class="mb-3">{{
          $vuetify.lang.t('$vuetify.courseManagement.lectureStep.EnableSuspend')
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            โปรดตรวจสอบจำนวนคำถามที่เลือกสุ่ม และจำนวนคำถามทั้งหมด
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="closeNoQuestionDialog"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import { Datetime } from "vue-datetime";
import { getListTagLevel } from '@/service/course/exam.js';
import { getUserTeacherList } from '@/service/account/manageUser';
import draggable from 'vuedraggable';
import buttonAddLecture from '@/views/course/dialog/insertLectureDialog.vue';
import buttonEditLecture from '@/views/course/dialog/editLectureDialog.vue';
import $ from 'jquery';
import { updateExamActive } from '@/service/course/exam.js';
import {
  getCourseById,
  updateCourse, //สำหรับ Studying type
  insertSection,
  updateSection,
  reorderSection,
  reorderLecture,
  deleteSection,
  deleteLecture,
} from '@/service/course/course';

export default {
  components: {
    // datetime: Datetime,
    draggable,
    buttonAddLecture,
    buttonEditLecture,
  },
  data() {
    return {
      valid: true,
      sections: [],
      enabled: true,
      detail: {},
      expand: true,
      params: {},
      dialogDelete: false,
      dialogSuccess: false,
      delSectionId: '',
      delLectureId: '',

      //Studying type
      learningOrder: false,
      studyingTypeSaving: false,
      studyingTypeSuccess: false,
      studyingTypeFail: false,

      // edit section
      editSectionDialog: false,
      isEditSection: false,
      sectionID: '',
      sectionName: '',
      sectionLecture: [],
      sectionRule: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.plsEnterSectionName'
          ),
      ],

      // edit lecture
      editLectureDialog: false,
      editLectureType: '',
      editSectionId: '',
      editLectureId: '',
      editLecture: [],
      openList: true,
      active: false,
      isModifyStartEndTime: false,
      startTime: '',
      endTime: '',
      activeDialog: false,
      currentLectureId: '',
      currentExamId: '',

      // deleteLecture
      deleteDialog: false,
      deleteSectionID: '',
      deleteLectureID: '',
      deleteArrayLecture: '',

      //check move
      open_panel_list: [],
      items: 0,
      old_panel: [],
      before_move_list: [],

      // check to save
      warnningToSaveDialog: false,
      old_section_name: '',

      noQuestionDialog: false,
      dialogCanNotPublish: false,
      statusActive: null,
      indexLecture: null,
      indexSection: null,
      selectInstructor: '',
      instructorList: [],
      searchdata: null,
      search: null,
      isSearch: false,
      ojbSection: null,
      arrTagLevel: [],
      loading: false,
    };
  },
  async mounted() {
    await this.initialize();
    console.log('Lecture Mounted');
    // $(".expand-panel").slideDown("slow");
  },
  watch: {
    // searchdata(keyword) {
    //   this.searchInfo(keyword);
    // },
    search(val) {
      console.log(val);
      if (val.search(' ') == -1) {
        this.searchInfo(val);
      }
    },
  },
  methods: {
    initialize() {
      this.paramsTeacher = {
        search: null,
        sort: 'created_at',
        sortby: -1,
        page: 1,
        limit: 10,
        active: 'null',
        isTeacher: 'y',
      };
      this.params = {
        id: this.$route.query.id,
      };
      this.getCourseDetail();
      this.getTeacherList();
      setTimeout(() => {
        if (this.sections.length != 0) {
          setTimeout(() => {
            this.items = this.sections.length;
            this.all();
          }, 2000);
        }
      }, 2000);
    },
    searchInfo(keyword) {
      this.paramsTeacher.search = keyword;
      this.getTeacherList();
    },
    cancelSearch() {
      console.log('objSection : ', this.ojbSection);
      this.isSearch = false;
      this.paramsTeacher.search = null;
      this.searchdata = null;
      this.getTeacherList();
      this.selectInstructor =
        this.ojbSection.teacher == '' ? [] : this.ojbSection.teacher._id;
    },
    checkOpenPanel() {
      this.old_open_panel = this.open_panel_list;
    },
    all() {
      this.open_panel_list = [...Array(this.items).keys()].map((k, i) => i);
      this.before_move_list = this.sections.map((section) => section.id);
    },
    closeLectureDialog() {
      this.editLectureDialog = false;
      this.editLectureType = '';
      this.getCourseDetail();
    },
    checkMoveSection() {
      //this.open_panel_list= this.old_open_panel;

      let sectionsID = this.sections.map((section) => section.id);
      this.reorderSection(sectionsID);
    },
    checkMoveLecture(index) {
      let sectionID = this.sections[index].id;
      let lecturesID = this.sections[index].lectures.map(
        (lecture) => lecture._id
      );
      this.reorderLecture(sectionID, lecturesID);
    },
    showDialogForm() {
      this.editSectionDialog = true;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async getListTagLevel(examId) {
      let params = {
        idexam: examId,
        sort: 'created_at',
        sortby: 1,
        page: 1,
        limit: 100,
      };
      this.arrTagLevel = [];
      let result = await getListTagLevel(params);
      console.log(result.data);
      if (result.data.length != 0) {
        result.data.forEach((level) => {
          this.arrTagLevel.push({
            id: level._id,
            text: level.title,
            numberOfQuestion: level.choose,
            countQuestion: level.countQuestion,
          });
        });
      }
      console.log(this.arrTagLevel);
    },
    editSection(section) {
      console.log(section);
      this.ojbSection = section;
      let lectures = section.lectures.map((lecture) => lecture._id);
      this.old_section_name = section.name;
      this.sectionName = section.name;
      this.sectionID = section.id;
      this.sectionLecture = lectures;
      // this.selectInstructor = this.selectInstructor[0]._id._id;
      this.selectInstructor = section.teacher == '' ? [] : section.teacher._id;
      this.isEditSection = true;
      this.editSectionDialog = true;
    },
    closeSectionDialog() {
      this.isEditSection = false;
      this.sectionName = '';
      this.sectionID = '';
      this.selectInstructor = '';
      this.editSectionDialog = false;
      this.warnningToSaveDialog = false;
      this.isSearch = false;
      this.searchdata = null;
    },
    openDeleteSectionDialog(sectionID) {
      this.deleteSectionID = sectionID;
      this.deleteDialog = true;
    },
    closeDeleteDialog() {
      this.deleteSectionID = '';
      this.deleteLectureID = '';
      this.deleteArrayLecture = [];
      this.deleteDialog = false;
    },
    async checkToPublish(
      index,
      indexlecture,
      lectureExamActive,
      lectureId,
      examId,
      totalQuestion,
      randomSetting
    ) {
      let checkPublish = 0;

      if (randomSetting == false) {
        if (lectureExamActive === false && totalQuestion == 0) {
          this.noQuestionDialog = true;
        } else {
          this.openActiveDialog(lectureExamActive, lectureId, examId);
        }
      } else {
        await this.getListTagLevel(examId);
        this.arrTagLevel.forEach((level, index) => {
          if (level.numberOfQuestion > level.countQuestion) {
            checkPublish += 1;
            let obj = {
              publish: false,
              ...this.arrTagLevel[index],
            };
            this.arrTagLevel[index] = obj;
          }
        });
        console.log(this.arrTagLevel, checkPublish);
        if (checkPublish > 0) {
          this.dialogCanNotPublish = true;
        } else {
          this.openActiveDialog(lectureExamActive, lectureId, examId);
        }
      }

      this.statusActive = lectureExamActive;
      this.indexLecture = indexlecture;
      this.indexSection = index;
      // console.log(lectureExamActive, lectureId, examId, totalQuestion)
    },
    closeNoQuestionDialog() {
      this.noQuestionDialog = false;
      this.dialogCanNotPublish = false;
      this.sections[this.indexSection].lectures[
        this.indexLecture
      ].exams[0].active = this.statusActive;
    },
    async openActiveDialog(lectureExamActive, lectureId, examId) {
      // let params = {
      //   idexam: examId
      // };
      // let questionList = await getQuestionList(params);
      // let questionListWithOutArticle = questionList.filter(question => question.typeQuestion !== 'article')
      // if(status.questionListWithOutArticle > 0)
      // console.log(status);

      this.activeDialog = true;
      this.active = lectureExamActive;
      this.currentLectureId = lectureId;
      this.currentExamId = examId;
    },
    closeActiveDialog() {
      this.activeDialog = false;
      this.sections[this.indexSection].lectures[
        this.indexLecture
      ].exams[0].active = this.active;
    },
    async saveActiveDialog() {
      this.loading = true;
      if (this.active) {
        await updateExamActive({
          id: this.currentExamId,
          active: false,
        });
        this.loading = false;
      } else {
        await updateExamActive({
          id: this.currentExamId,
          active: true,
        });
        this.loading = false;
      }
      this.getCourseDetail();
      this.activeDialog = false;
    },
    openDeleteLectureDialog(sectionID, lectureID, arrlectures) {
      this.deleteSectionID = sectionID;
      this.deleteLectureID = lectureID;
      this.deleteArrayLecture = arrlectures;
      this.deleteDialog = true;
    },
    deleteItem() {
      if (this.deleteLectureID.length > 2) {
        this.deleteLecture(this.deleteSectionID, this.deleteLectureID);
      } else {
        this.deleteSection(this.deleteSectionID);
      }
    },
    deleteLectureConfirm(sectionID, lectureID) {
      this.dialogDelete = true;
      this.delSectionId = sectionID;
      this.delLectureId = lectureID;
    },
    async deleteLecture(sectionID, lectureID) {
      //dialog delete
      this.dialogDelete = false;
      this.dialogSuccess = true;
      await deleteLecture({
        idsection: sectionID,
        idlecture: lectureID,
      });

      this.closeDeleteDialog();
      this.getCourseDetail();
    },
    async deleteSection(sectionID) {
      this.dialogDelete = false;
      this.dialogSuccess = true;
      await deleteSection({
        idcourse: this.$route.query.id,
        idsection: sectionID,
      });

      this.closeDeleteDialog();
      this.getCourseDetail();
    },
    async getCourseDetail() {
      this.detail = await getCourseById(this.params);
      this.learningOrder = this.detail.learningOrder;
      this.sections = [];

      this.detail.sections.forEach((section) => {
        let lectures = [];
        section.lectures.forEach((lecture) => {
          let lectureType = {};
          switch (lecture.type) {
            case 'VDO':
              lectureType = {
                icon: 'mdi-video-outline',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.video'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'YOUTUBE':
              lectureType = {
                icon: 'mdi-youtube',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.youtube'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'PDF':
              lectureType = {
                icon: 'mdi-file-document-outline',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.document'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'IMG':
              lectureType = {
                icon: 'mdi-image-outline',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.photo'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'EXAM':
              lectureType = {
                icon: 'mdi-format-annotation-plus',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.examination'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'FILE':
              lectureType = {
                icon: 'mdi-paperclip',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.otherFiles'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'BOOK':
              lectureType = {
                icon: 'mdi-book-open-page-variant',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.book'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'URL':
              lectureType = {
                icon: 'mdi-link-variant',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.website'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            case 'BLOG':
              lectureType = {
                icon: 'mdi-format-float-left',
                name: this.$vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.article'
                ),
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;

            default:
              lectureType = {
                icon: 'mdi-format-float-left',
                iconClass: 'grey lighten-1 black--text',
                ...lecture,
              };
              break;
          }

          lectures.push(lectureType);
        });
        this.sections.push({
          id: section._id,
          name: section.title,
          number: section.lectures.length,
          lectures: lectures,
          teacher: section.teacher
            ? section.teacher
            : this.detail.owner_by_students[0]._id,
        });
      });
      console.log(this.sections);
    },
    async getTeacherList() {
      this.instructorList = [];
      let resultTeacher = await getUserTeacherList(this.paramsTeacher);
      let resultIsTeacher = await resultTeacher.data.filter(
        (filter) => filter.isTeacher === 'y'
      );
      await resultIsTeacher.forEach(async (teacher) => {
        this.instructorList.push({
          id: teacher._id,
          fullName: teacher.prefix
            ? teacher.prefix + ' ' + teacher.firstName + ' ' + teacher.lastName
            : teacher.firstName + ' ' + teacher.lastName,
          email: teacher.email,
          username: teacher.username,
        });
      });
    },
    async reorderSection(sections) {
      await reorderSection({
        id: this.detail._id,
        sections: sections,
      });
      this.getCourseDetail();
    },
    async reorderLecture(sectionID, lectures) {
      await reorderLecture({
        id: sectionID,
        lectures: lectures,
      });
      this.getCourseDetail();
    },
    async reload() {
      this.getCourseDetail();
    },
    async insertOrUpdateSection() {
      if (this.isEditSection) {
        await updateSection({
          id: this.sectionID,
          title: this.sectionName,
          lectures: this.sectionLecture,
          idteacher: this.selectInstructor,
        });
      } else {
        await insertSection({
          id: this.detail._id,
          title: this.sectionName,
          lectures: [],
          idteacher: this.selectInstructor
            ? this.selectInstructor
            : this.detail.owner_by_students[0]._id._id,
        });
      }

      this.closeSectionDialog();
      this.getCourseDetail();
    },
    openExpand(id) {
      let panel = $('#expand-' + id);
      let btn = $('#centerx-ele-' + id);
      btn.attr('disabled', true);
      if (panel.hasClass('active')) {
        panel.slideUp('slow');
        panel.removeClass('active');
        btn.removeClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      } else {
        panel.slideDown('slow');
        panel.addClass('active');
        btn.addClass('active');
        setTimeout(() => {
          btn.attr('disabled', false);
        }, 1000);
      }
    },
    async openEditDialog(type, sectionId, lectureId, lecture) {
      this.editLectureDialog = true;
      this.editLectureType = type;
      this.editSectionId = sectionId;
      this.editLectureId = lectureId;
      this.editLecture = lecture;
    },
    async goBack() {
      if (this.$route.query.id) {
        this.$router.push({
          path: '/course/detail',
          query: {
            id: this.$route.query.id,
            step: 1,
          },
        });
      }
    },
    async goNext() {
      //  await this.$router.replace({
      //     path: "/course/detail",
      //     query: { id: this.courseID, step: 1 }
      //   });
      if (this.$route.query.id) {
        this.$router.push({
          path: '/course/detail',
          query: {
            id: this.$route.query.id,
            step: 3,
          },
        });
      }
    },
    checkToSave() {
      if (this.isEditSection) {
        this.sectionName === this.old_section_name
          ? this.closeSectionDialog()
          : (this.warnningToSaveDialog = true);
      } else {
        this.sectionName != ''
          ? (this.warnningToSaveDialog = true)
          : this.closeSectionDialog();
      }
    },
    async saveStudyingType() {
      this.studyingTypeSuccess = false;
      this.studyingTypeFail = false;
      this.studyingTypeSaving = true;

      let status = null;
      let valueData = {
        ...this.detail,
        learningOrder: this.learningOrder,
        id: this.$route.query.id,
      };

      status = await updateCourse(valueData);

      this.studyingTypeSaving = false;
      if (status.code == 403) {
        this.studyingTypeFail = true;
      } else {
        this.studyingTypeSuccess = true;
      }
    },
  },
};
</script>

<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}

.button-secondary {
  color: rgb(65, 65, 65);
  border: 1px solid rgb(195, 195, 195);
}
.text-primary {
  color: rgb(66, 154, 216) !important;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}

.lesson-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 0px 0px 15px 15px;
  transition: transform 0.3s ease-in-out;
}

.mb0 {
  margin-bottom: 0px;
}

.lg-w-80 {
  width: 80%;
}

.md-position-relative {
  position: relative !important;
}

.md-position-absolute {
  position: absolute;
}

.centerx-ele {
  left: 50%;
  transform: translate(-50%, 0);
  top: 0;
}

.centerx-ele.active .icon {
  transform: rotate(180deg);
}

.noti {
  background: #2196f3;
  color: white;
}

.noti p {
  color: white;
}

.list-group {
  width: 100%;
}

@media only screen and (max-width: 768px) {
  .xs-full-width {
    width: 100%;
  }
}
</style>
<style>
.card-custom-lecture {
  /* box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19) !important;
  transition: transform 0.3s ease-in-out !important; */
  border-radius: 2px 2px 0 0 !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-bottom: 0 !important;
  background: #fafafa !important;
}
.card-child-lecture {
  border-radius: 0 0 2px 2px !important;
  /* border: 1px solid #e0e0e0 !important; */
  border-top: 0 !important;
}
</style>
